import { createMuiTheme } from '@material-ui/core/styles';

// See https://material-ui.com/customization/default-theme/ for all options.

const theme = createMuiTheme({
  palette: {
    primary: { main: '#295F91' },
  },
  typography: {
    useNextVariants: true,
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/configs/theme.js